// extracted by mini-css-extract-plugin
module.exports = {"faq":"faq_faq__YJ5h3","heading":"faq_heading__3oCjq","rows":"faq_rows__R4CU8","row":"faq_row__kGGPB","question":"faq_question__nPH1h","answer":"faq_answer__rwxfw"};